export default "/_next/static/fonts/Graphik-RegularItalic-0eabd6bcddbadd80aa485273f9da60a9.woff";